import { useEffect, useState } from 'react';
import publicApi from '../services/public.api';

const CACHE_KEY = 'siteSettings';

function readCachedSettings() {
  try {
    const cached = localStorage.getItem(CACHE_KEY);
    if (cached) return JSON.parse(cached);
  } catch (e) {
    console.error('Error reading site settings cache:', e);
  }
  return null;
}

/**
 * Loads public site settings (branches, phones, etc.) with localStorage cache.
 */
export function useSiteSettings() {
  const [settings, setSettings] = useState(readCachedSettings);
  const [loading, setLoading] = useState(!readCachedSettings());

  useEffect(() => {
    let cancelled = false;

    const fetchSettings = async () => {
      try {
        const response = await publicApi.getSettings();
        if (!cancelled && response?.success) {
          setSettings(response.data);
          localStorage.setItem(CACHE_KEY, JSON.stringify(response.data));
        }
      } catch (error) {
        console.error('Error fetching site settings:', error);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchSettings();
    return () => {
      cancelled = true;
    };
  }, []);

  return { settings, loading };
}
